import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { Pv2PlayableListItemComponent } from './playable-list-item.component';
import { Pv2ContentMenuItem } from '../../../models';

/**
 * A vertical list of playable elements, composed of three columns
 * * A play button
 * * Multiline Description (label, description)
 * * Duration
 */
@Component({
  selector: 'pv2-playable-list',
  templateUrl: 'playable-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Pv2PlayableListItemComponent],
})
export class Pv2PlayableListComponent {
  public readonly items = input.required<Pv2ContentMenuItem[] | undefined>();
  public readonly eventSource = input.required<string>();
  public displayPlayButtons = input(true, { transform: booleanAttribute });
  public displayDurations = input(true, { transform: booleanAttribute });
}
